module.exports = __webpack_public_path__ + "img/bg-bottom-left.46525f60.svg";